import baseChart from './customBaseChart';

export default (opt = {}) => {

  const list = opt.list || [];

  const data = {
    countValue: 0,
    legend: [],
    list: []
  };
  
  list.forEach(item => {
    const val = parseFloat(item.value);
    data.countValue += (isNaN(val) ? 0 : val);
    
  });

  console.log(opt);
  
  return Object.assign(baseChart(opt), {

    legend: {
      bottom: 10,
      left: 'center',
      data: list.map(item => item.name) || ['西凉', '益州', '兖州', '荆州', '幽州']
    },
    series: [
      {
        type: 'pie',
        radius: '65%',
        center: ['50%', '50%'],
        selectedMode: 'single',
        data: list.map(item => ({
          ...item,
          label: {
            normal: {
              position: (100 * item.value / data.countValue) > 5 ? 'inside' : 'outside',
              formatter($item) {
                return `${$item.name}\n${$item.percent}%`
              }
            }
          },
          itemStyle: {
            normal: {
              color: item.color || ''
            }
          }
        })) || [
          {
            value: 1548,
            name: '幽州'
          },
          { value: 535, name: '荆州' },
          { value: 510, name: '兖州' },
          { value: 634, name: '益州' },
          { value: 735, name: '西凉' }
        ]
      }
    ]
  });
}


// WEBPACK FOOTER //
// src/chart/chartPie.js